(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rr-tray-specifications"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select',function(event){const details=event.target.closest('.rr-specs-size');if(details&&details.tagName==='DETAILS'){details.open=true;}});

  } catch(e) { console.error(e); }
})();
})();
